import createIcon from '../../createIcon';

/**
 * @component @name LocalFireDepartment
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMTMuOUw5Ljg3IDE1Ljk5QzkuMzEgMTYuNTUgOSAxNy4yOCA5IDE4LjA2QzkgMTkuNjggMTAuMzUgMjEgMTIgMjFDMTMuNjUgMjEgMTUgMTkuNjggMTUgMTguMDZDMTUgMTcuMjggMTQuNjkgMTYuNTQgMTQuMTMgMTUuOTlMMTIgMTMuOVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNiA3TDE1LjU2IDcuNTVDMTQuMzggOS4wMiAxMiA4LjE5IDEyIDYuM1YzQzEyIDMgNCA3IDQgMTRDNCAxNi45MiA1LjU2IDE5LjQ3IDcuODkgMjAuODZDNy4zMyAyMC4wNyA3IDE5LjEgNyAxOC4wNkM3IDE2Ljc0IDcuNTIgMTUuNSA4LjQ3IDE0LjU2TDEyIDExLjFMMTUuNTMgMTQuNTdDMTYuNDggMTUuNSAxNyAxNi43NCAxNyAxOC4wN0MxNyAxOS4wOSAxNi42OSAyMC4wMyAxNi4xNSAyMC44MkMxOC4wNCAxOS42NyAxOS40NCAxNy43NiAxOS44NiAxNS41MkMyMC41MiAxMS45NyAxOC43OSA4LjYyIDE2IDdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LocalFireDepartment = createIcon('LocalFireDepartment', [
  [
    'path',
    {
      d: 'M12 13.9L9.87 15.99C9.31 16.55 9 17.28 9 18.06C9 19.68 10.35 21 12 21C13.65 21 15 19.68 15 18.06C15 17.28 14.69 16.54 14.13 15.99L12 13.9Z',
      key: '1kmmxw',
    },
  ],
  [
    'path',
    {
      d: 'M16 7L15.56 7.55C14.38 9.02 12 8.19 12 6.3V3C12 3 4 7 4 14C4 16.92 5.56 19.47 7.89 20.86C7.33 20.07 7 19.1 7 18.06C7 16.74 7.52 15.5 8.47 14.56L12 11.1L15.53 14.57C16.48 15.5 17 16.74 17 18.07C17 19.09 16.69 20.03 16.15 20.82C18.04 19.67 19.44 17.76 19.86 15.52C20.52 11.97 18.79 8.62 16 7Z',
      key: 'ovv737',
    },
  ],
]);

export default LocalFireDepartment;
